import { PageLayoutProps, PageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { Dispatch, SetStateAction, useCallback } from 'react';

type UsePageLayoutContentRenderedCallback = (
  setShouldDisplayContentPanelButton: Dispatch<SetStateAction<boolean>>
) => NonNullable<PageLayoutProps['onPageLayoutContentRendered']>;
export const usePageLayoutContentRenderedCallback: UsePageLayoutContentRenderedCallback = (
  setShouldDisplayContentPanelButton
) =>
  useCallback(
    ({ isSidebarVisible, isSidebarInPanel, width }) => {
      if (!isSidebarVisible) {
        setShouldDisplayContentPanelButton(false);

        return;
      }

      const shouldDisplayContentPanelButton = isSidebarInPanel && width === PageLayoutWidth.Medium;
      setShouldDisplayContentPanelButton(shouldDisplayContentPanelButton);
    },
    [setShouldDisplayContentPanelButton]
  );
